// UserContext.js
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [licenseDatas, setLicenseData] = useState({
    nocNumber: localStorage.getItem('nocNumber'),
    limitPerDay: localStorage.getItem('limitPerDay'),
    limitPerYear: localStorage.getItem('limitPerYear'),
    nocStartDate: localStorage.getItem('nocStartDate'),
    nocEndDate: localStorage.getItem('nocEndDate'),
    borewellCount: localStorage.getItem('borewellCount'),
    companyLogoUrl: localStorage.getItem('companyLogoUrl'),
  });

  const updateLicenseData = useCallback((data) => {
    // Update state
    setLicenseData((prev) => ({
      ...prev,
      ...data,
    }));

    // Persist to localStorage
    Object.entries(data).forEach(([key, value]) => {
      localStorage.setItem(key, value ?? '');
    });
  }, []);

  const value = useMemo(
    () => ({ licenseDatas, updateLicenseData }),
    [licenseDatas, updateLicenseData],
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
